import branchService from 'ApiService/SuperAdmin/branchService';
import GenericUserList from '../../../List/GenericUserList';

const AdminList = () => {
  const columns = [
    { header: 'Admin Name', key: 'name' },
    { header: 'Email', key: 'email' },
    // { header: 'Gender', key: 'gender' },
    // { header: 'Date of Birth', key: 'dob' },
    // { header: 'Institute ID', key: 'instituteId' },
    { header: 'Branch', key: 'branchName' },
    { header: 'Location', key: 'branchLocation' },
    { header: 'Contact No', key: 'contact' },
  ];

  const fetchTeachers = async (userId, page) => {
    return await branchService.getAllAdmin(userId, page);
  };

  const updateTeacher = async (teacherData) => {
    return await branchService.updateAdmin(teacherData);
  };

  return (
    <GenericUserList
      fetchUsers={fetchTeachers}
      updateUser={updateTeacher}
      userType="Admin"
      columns={columns}
    />
  );
};

export default AdminList;
